<div >

    <div *ngIf="status != 'loggedin'" class="mt-1 mb-4">


        <button class="btn btn-primary mb-2" (click)="setCheckoutCustomerType('current_customer')">
            {{'already_have_an_account' | translate}}
        </button>&nbsp;
        <button class="btn btn-success mb-2" (click)="setCheckoutCustomerType('new_customer')" i18n> {{'new_customer'|translate}}</button>
        <span style="font-weight: bold ; padding: 5px"> {{'or' | translate}}  </span>
        <button class="btn btn-warning mb-2" (click)="setCheckoutCustomerType('guest')" i18n> {{'continue_as_guest' | translate}}</button>
    </div>

    <div *ngIf="customer_type == 'current_customer' && this.status != 'loggedin'" class="mt-4 card">
        <app-in-cart-login></app-in-cart-login>

    </div>

    <div *ngIf="customer_type == 'new_customer' && this.status != 'loggedin'" class="mt-4 card">
        <app-registration (showLoginSelectedEvent)="setCheckoutCustomerType('current_customer')"></app-registration>
    </div>

    <div *ngIf="customer_type == 'guest' && this.status != 'loggedin'" class="mt-4 card">
     <app-guest-registration (showLoginSelectedEvent)="setCheckoutCustomerType('guest')"></app-guest-registration>
    </div>
</div>
